import Vue from 'vue'

import currency from './currency'
import date from './date'
import datetime from './datetime'
import friendlyDisplayKeys from './friendlyDisplayKeys'
import friendlyDisplayValue from './friendlyDisplayValue'
import phone from './phone'

const loadFilters = () => {
  Vue.filter('currency', currency)
  Vue.filter('date', date)
  Vue.filter('datetime', datetime)
  Vue.filter('friendlyDisplayKeys', friendlyDisplayKeys)
  Vue.filter('friendlyDisplayValue', friendlyDisplayValue)
  Vue.filter('phone', phone)
}

export {
  currency,
  date,
  datetime,
  friendlyDisplayKeys,
  friendlyDisplayValue,
  phone,

  loadFilters,
}
